<div class="tabbable__body no-margin">
  <h2>Attest</h2>
  <br>
  <dot-loader [visibility]="loadingInvoices.waitingForApproval || loadingInvoices.approved"></dot-loader>
  @if(!loadingInvoices.waitingForApproval && !loadingInvoices.approved) {
    <h3 class="margin-top--2x">Väntar på att godkännas</h3>
    <app-woo-table [data]="invoices.waitingForApproval" [noDataText]="'Det finns inga fakturor som väntar på att godkännas.'" expandable="true" [expandedTpl]="detailTpl">
      <woo-table-column name="campaign_order_reference" header="Orderreferens"></woo-table-column>
      <woo-table-column name="total_gross" header="Belopp">
        <ng-template let-cell>{{ cell.value | currency : 'SEK' :'symbol':'1.0-0' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="invoice_date" header="Datum för kredit">
        <ng-template let-cell>{{ cell.value | date : 'yyyy-MM-dd' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="attest_status" header="Status">
        <ng-template let-cell>
          @if(cell.value === 'awaiting_attest') {
            <button class="button primary-1 success margin--none" (click)="attestInvoice(cell.row.id)">Attestera faktura</button>
          } @else {
            <button class="btn margin--none" >Skickad innan attestregler</button>
          }
        </ng-template>
      </woo-table-column>
    </app-woo-table>
    <h3>Skickade kreditfakturor</h3>

    <app-woo-table [data]="invoices.approved" [noDataText]="'Det finns inga fakturor som väntar på att godkännas.'" expandable="true" [expandedTpl]="detailTpl">
      <woo-table-column name="campaign_order_reference" header="Orderreferens"></woo-table-column>
      <woo-table-column name="total_gross" header="Belopp">
        <ng-template let-cell>{{ cell.value | currency : 'SEK' :'symbol':'1.0-0' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="invoice_date" header="Datum för kredit">
        <ng-template let-cell>{{ cell.value | date : 'yyyy-MM-dd' }}</ng-template>
      </woo-table-column>
      <woo-table-column name="attest_status" header="Status">
        <ng-template let-cell>
          @if(cell.value === 'attested_ok') {
            <span>
              <div class="display--flex">Godkänd<div class="status__badge with--icon success small display--inline-block margin-left--1x"></div></div>
            </span>
          } @else {
            Skickad innan attestregler 
          }
        </ng-template>
      </woo-table-column>
    </app-woo-table>
  }

  <ng-template #detailTpl let-data>
      <p>Kampanjnamn: <a href="javascript:void(0)" (click)="showCampaign(data.row.campaign_id)">{{ data.row.campaign_name }}</a></p>
      <p>Kundnamn: {{ data.row.customer_name }}</p>
      @if(data.row.agency_name) {
        <p>Mediebyrå: {{ data.row.agency_name }}</p>
      }
      <p>Attesterare: {{ data.row.attest_user }}</p>
      <p>Datum för attest: {{ data.row.attested_at | date : 'yyyy-MM-dd' }}</p>
  </ng-template>
</div>
